module.exports = __webpack_public_path__ + "static/media/pcb3.296266bf.jpg";